import React, {useMemo} from "react";
import dynamic from "next/dynamic";
import styled, {withTheme} from "styled-components";
import "react-dropdown/style.css";
import {logModuleLoadError} from "src/core/common/utils";

const Dropdown = dynamic(() =>
  import("react-dropdown").catch(logModuleLoadError("react-dropdown"))
);

function SimpleSelect({options, placeholder, ...props}) {
  const filteredOptions = useMemo(() => {
    return options.filter((opt) => opt.label !== "" || opt.value !== "");
  }, [options]);

  return (
    <Wrapper hasErrors={props.hasErrors}>
      <Dropdown options={filteredOptions} placeholder={placeholder} {...props} />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  & .Dropdown-root {
    position: relative;
    box-sizing: border-box;
  }
  & .Dropdown-control {
    background: #fafafa;
    padding: 0 ${(props) => props.theme.v2.spacing(4)};
    border: ${(props) => (props.hasErrors ? "1px solid red" : "1px solid #ebebeb")};
    color: ${(props) =>
      props.hasErrors ? "red" : props.theme.v2.color.base.grey["900"]};
    font-family: ${(props) => props.theme.v2.typography.body.family};
    font-size: ${(props) => props.theme.v2.typography.sizing.m.lg};
    line-height: calc(${(props) => props.theme.v2.typography.sizing.m.lg} + 3px);
    height: 51px;
    width: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    border-radius: ${(props) => props.theme.v2.decoration.border.radius.default};
    transition: 100ms border-color ease-out;
  }
  & .Dropdown-control:hover {
    border-color: hsl(0, 0%, 70%);
  }
  & .Dropdown-menu {
    margin-top: ${(props) => props.theme.v2.spacing(2)};
    padding-top: ${(props) => props.theme.v2.spacing(1)};
    padding-bottom: ${(props) => props.theme.v2.spacing(1)};
    border-radius: ${(props) => props.theme.v2.decoration.border.radius.default};
    z-index: 999;
  }
  & .Dropdown-option {
    color: ${(props) => props.theme.v2.color.base.grey["900"]};
    font-family: ${(props) => props.theme.v2.typography.body.family};
    font-size: ${(props) => props.theme.v2.typography.sizing.m.lg};
  }
  .Dropdown-option:hover {
    background-color: #f6f6f6;
  }
  & .Dropdown-option.is-selected {
    background-color: #f6f6f6;
  }
  & .Dropdown-arrow {
    top: 22px;
  }
`;

export default withTheme(SimpleSelect);
